import { useState } from 'react';
import Logo from './assets/kureme-logo.png';
import './App.css';

export default function App() {
  const [isOpen, setIsOpen] = useState(false)
  const toggleImprint = () => {
    {
      setIsOpen(prevActive => !prevActive)
      }
  };

  return (<>
  <div className="main-logo">
    <img
      src={Logo}
      alt="kur'eme"
      className="landing-logo"
    />
    </div>
    <div className='contact-container'>
      <h2 
      className='contact-us-text text-white'
      style={{
          fontFamily:
            "'Adobe Caslon Pro', 'Adobe Caslon', 'Caslon', serif",
        }}>Contact Us</h2>
      <div>
        <div className="contact-text-container">
          <a
            href="tel:+017632465605"
            className="contact-text"
          >
            017632465605
          </a>
        </div>

        <div className="contact-text-container">
          <p className="contact-text">
            Adalbertstraße 23
            <br />
            Berlin, Berlin 10997
          </p>
        </div>
      </div>

      <div className="imprint-container" onClick={() => toggleImprint()}>
        <p
          className="imprint-text"
        >
          Imprint
        </p>
      </div>
    </div>

    { isOpen &&
    
    <div className="imprint-popup-container mx-auto px-8 pt-32 pb-16 max-w-4xl">
        <div className="text-white">
          <h1
            className="text-white text-4xl md:text-5xl font-light mb-8"
            style={{
              fontFamily: "'Adobe Caslon Pro', 'Adobe Caslon', 'Caslon', serif",
            }}
          >
            Impressum
          </h1>

          <div className="prose prose-invert max-w-none text-white/90 space-y-6 leading-relaxed">
            <div>
              <p className="mb-6 text-white">
                <strong>Angaben gemäß § 5 TMG</strong>
                <br />
                DUDU Ventures UG (haftungsbeschränkt)
                <br />
                Dresdner Straße 253
                <br />
                01705 Freital
                <br />
                Handelsregister: 224232 B<br />
                Registergericht: Amtsgericht Charlottenburg
                <br />
                Vertreten durch: Duong Nguyen
              </p>

              <p className="mb-6 text-white" >
                <strong>Postadresse</strong>
                <br />
                Kuréme
                <br />
                Adalbertstraße 23
                <br />
                10997 Berlin
              </p>

              <p className="mb-6 text-white">
                <strong>Umsatzsteuer-Identifikationsnummer gemäß § 27 a</strong>{" "}
                Umsatzsteuergesetz: DE340352161
              </p>

              <div className="mb-6 text-white">
                <strong>Haftungsausschluss</strong>
                <br />
                <p className="mt-2 text-white">
                  Alle Texte und Links wurden sorgfältig geprüft und werden
                  ständig aktualisiert. Wir bemühen uns, auf dieser Website
                  richtige und vollständige Informationen zur Verfügung zu
                  stellen, übernehmen jedoch keinerlei Verantwortung, Garantien
                  oder Haftung für die Richtigkeit, Vollständigkeit oder
                  Aktualität der über diese Website bereitgestellten
                  Informationen. Wir behalten uns das Recht vor, die
                  Informationen auf dieser Website jederzeit und ohne vorherige
                  Ankündigung zu ändern, und übernehmen keine Verpflichtung zur
                  Aktualisierung der darin enthaltenen Informationen. Alle Links
                  zu externen Anbietern wurden zum Zeitpunkt der Aufnahme auf
                  ihre Richtigkeit geprüft, jedoch haften wir nicht für den
                  Inhalt und die Verfügbarkeit von Websites, die mittels eines
                  Hyperlinks zu erreichen sind. Für illegale, fehlerhafte oder
                  unvollständige Inhalte und insbesondere für Schäden, die aus
                  dem Inhalt verlinkter Seiten entstehen, haftet allein der
                  Anbieter der Seite, auf die verwiesen wurde. Dabei spielt es
                  keine Rolle, ob der Schaden direkter, indirekter oder
                  finanzieller Natur ist oder ob es sich um einen sonstigen
                  Schaden handelt, der durch Datenverlust, Nutzungsausfall oder
                  andere Gründe jeglicher Art entstehen könnte.
                </p>
              </div>

              <p className="mb-6 text-white">
                <strong>Angaben zur Berufs­haftpflicht­versicherung</strong>
                <br />
                Name und Sitz des Versicherers:
                <br />
                Berufsgenossenschaft Nahrungsmittel und Gastgewerbe (BGN)
                <br />
                Körperschaft des öffentlichen Rechts
                <br />
                Dynamostraße 7-11
                <br />
                68165 Mannheim
              </p>

              <p className="mb-6 text-white">
                <strong>EU-Streitschlichtung</strong>
                <br />
                Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung (OS) bereit:{" "}
                <a
                  href="https://ec.europa.eu/consumers/odr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-white/80 underline"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
                .<br />
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </div>
          </div>
        </div>
      </div>
    }
    
    
  </>);
}